import React, { Component, createRef } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import onClickOutside from 'react-onclickoutside';

import { selectedLang, getMenu } from '../.././../../actions';
import { URL_PATH } from "../../../../../constants";
import "./style.scss";
import { LANGUAGE } from '../../../../../constants';
// import {createUrl,removeClass} from '../../../../../utils/common';
import { MODALS } from '../../../general/Modal/constants';
import { openPopup, closePopup } from '../../Modal/action';

class ActionMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showSearchSuggestion: false,
            profileactive: false,
            isUpdate: false,
            isVisible: false,
            otherDevices: true,
        }
        this.selectorRef = React.createRef(null);
    }

    componentDidMount() {
        let { location: { pathname } } = this.props;
        const winWidth = document.body.clientWidth ||
            document.documentElement.clientWidth;
        this.loadHandler();
        pathname === "/" && window.addEventListener("scroll", this.listenToScroll);
        if (winWidth >= 1170) {
            this.setState({
                otherDevices: true,
            })
        } else this.setState({
            otherDevices: false,
        })
        window.addEventListener("mousedown", this.handleClickOutside);
    }

    componentDidUpdate = (prevProps) => {
        if ((this.props.location.pathname !== prevProps.location.pathname) && this.state.isUpdate) {
            this.updateMenu();
        }
    }

    // handleClickOutside = (event) => {
    //     let element = document.getElementsByClassName("profile")[0];
    //     if(includes(element.classList, 'active') ){
    //         removeClass(element, 'active')
    //         this.setState({
    //             profileActive: !this.state.profileActive
    //         })
    //     }
    //     if(this.state.showSearchSuggestion){
    //         this.setState({
    //             showSearchSuggestion: !this.state.showSearchSuggestion
    //         })
    //     }
    // };
    loadHandler = () => {
        //const {location}=this.props;
        //let lang = window.location.pathname.split('/')[1].match(/en|hi/) || LANGUAGE.EN;
    };

    switchLang = (event) => {
        const { selectedLang, location: { pathname }, getMenu } = this.props;
        let selectedValue = event.currentTarget.getAttribute('data-val');
        let cookieTime = 365 * 24 * 60 * 60;
        if (selectedValue == pathname.split('/')[1]) {
            return;
        }
        cookie.save('selectedLanguage', selectedValue, { path: '/', maxAge: cookieTime, secure: true, sameSite: 'strict' });
        selectedLang(selectedValue);
        getMenu(selectedValue);
        let newUrl;
        if (pathname.split('/')[1].match(/en|hi/)) {
            let locArr = pathname.split('/');
            locArr[1] = selectedValue;
            newUrl = locArr.join('/');
        } else {
            newUrl = pathname != '/' ? `${selectedValue}${pathname}` : `${selectedValue}`;
        }
        this.props.history.push(newUrl);
    };
    showModal = () => {
        const { openPopup, closePopup } = this.props;
        const modalData = {
            okAction: () => {
                closePopup();
            },
            closeAction: () => {
                closePopup();
            },
        };
        // openPopup(MODALS.ALERT, modalData);
        this.props.openPopup(MODALS.AUTH, modalData);
    };
    routeToFavourites = () => {
        let { history } = this.props;
        history.push(URL_PATH.FAVORITES);
    };

    initGlobalSearch = (type = 'typing') => {
        window.location.href = "/search";
    }
    updateMenu = () => {
        this.state.isUpdate ? this.setState({
            isUpdate: false,
        }) : this.setState({
            isUpdate: true,
        })
    }
    hideSearchBar = () => {
        this.setState({ showSearchSuggestion: false });
    }
    onSearch = (type) => {
        const { openPopup } = this.props;
        return (
            openPopup(MODALS.SEARCH_MODAL, { modalClass: 'search-container', type: type })
        )
    }

    listenToScroll = () => {
        let heightToShowFrom = 20;
        let maxWidthAllowed = 1170;
        let { isVisible } = this.state;
        const winScroll = document.body.scrollTop ||
            document.documentElement.scrollTop;
        const winWidth = document.body.clientWidth ||
            document.documentElement.clientWidth;

        if ((winScroll > heightToShowFrom) && (winWidth < maxWidthAllowed)) {
            !isVisible &&
                this.setState({ isVisible: true });
        } else {
            this.setState({ isVisible: false });
        }
    };

    handleClickOutside = (e) => {
        if (this.state.isUpdate && this.selectorRef.current && !this.selectorRef.current.contains(e.target)) {
            this.updateMenu();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.listenToScroll);
        window.removeEventListener("mousedown", this.handleClickOutside);
    }

    render() {
        const { history, location, menu, location: { pathname }, fromNavigationMenu, fromAccessibilityMenu } = this.props;
        let { showSearchSuggestion, profileActive, isVisible, otherDevices } = this.state;
        let isChrome = navigator.userAgent.indexOf("Chrome") !== -1
        let isFireFox = navigator.userAgent.indexOf("Firefox") !== -1
        let isSafari = !(isChrome || isFireFox)


        return (

            <div className="nav-item align-self-center">
                {/* <form className="global-search position-relative"> */}
           
                    {pathname === "/" && !fromNavigationMenu && 
                    <div className={isVisible ? "search-bar" : "search-bar visible"}>

                        {/* <div className="searchdesk"> */}
                                <img
                                    className="search mx-2"
                                    // src="/images/New/white-search-arrow.svg"
                                    src="/images/New/grey-search.svg"
                                    alt="search-icon-in-grey"
                                    width={22}
                                    height={22}
                                    onClick={this.initGlobalSearch}
                                />
                            {/* <div className="form-group">
                                <input
                                    type="search"
                                    className="form-control"
                                    placeholder="Search"
                                    onClick={this.initGlobalSearch}
                                />
                            </div> */}
                            
                        {/* </div> */}

                        {/* <a className="" onClick={this.initGlobalSearch} >
                            <img className="Search" src="/images/New/search.svg" alt="" />
                        </a> */}
                    </div>}
                    {pathname === "/" && isVisible && !otherDevices && 
                    <a href="/search" className='voice-and-search-icon'><img src="/images/homeIcons/search-and-voice.png" alt="home icon"></img></a>}
                    {pathname !== "/" && !fromNavigationMenu   && 
                    <div className={isVisible ? "search-bar" : "search-bar visible"}>

                        {/* <div className="searchdesk"> */}
                                <img
                                    className="search mx-2"
                                    // src="/images/New/white-search-arrow.svg"
                                    src="/images/New/grey-search.svg"
                                    alt="search-icon-in-grey"
                                    width={22}
                                    height={22}
                                    onClick={this.initGlobalSearch}
                                />
                            {/* <div className="form-group">
                                <input
                                    type="search"
                                    className="form-control "
                                    placeholder="Search"
                                    onClick={this.initGlobalSearch}
                                />
                            </div> */}
                            
                        {/* </div> */}
                        {/* <a className="" onClick={this.initGlobalSearch} >
                            <img className="Search" src="/images/New/search.svg" alt="" />
                        </a> */}

                    </div>}

                    {/* <div className="Search mb-md-2 me-1" onClick={this.initGlobalSearch} >
                        <img src="/images/New/blue_search.svg" alt="blue search icon" width={25} height={25}/>
                    </div> */}

                {/* </form> */}
            </div>


        )
    }


}

const mapStateToProps = (state) => ({
    currentSelected: state.commonContent.currentSelected,
});

const mapDispatchToProps = (dispatch) => ({
    selectedLang: bindActionCreators(selectedLang, dispatch),
    openPopup: bindActionCreators(openPopup, dispatch),
    closePopup: bindActionCreators(closePopup, dispatch),
    getMenu: bindActionCreators(getMenu, dispatch),
});
// ActionMenu = onClickOutside(ActionMenu);
export default connect(mapStateToProps, mapDispatchToProps)(ActionMenu);


ActionMenu.propTypes = {
    selectedValue: PropTypes.string,
    location: PropTypes.object,
    history: PropTypes.object,
};
